// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Post.module.cssの該当部分をコピーして流用 */
.ImageUploader_imageUploadBlock__SlETU {
  margin-bottom: 12px;
  display: flex;
  flex-direction: column;
}
.ImageUploader_addImageButton__gRKJT {
  margin-left: 8px;
  padding: 2px 10px;
  background: #1976d2;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
.ImageUploader_imagePreviewArea__wOZBI {
  display: flex;
  gap: 8px;
  margin-top: 8px;
}
.ImageUploader_imagePreviewWrapper__9vgXg {
  position: relative;
}
.ImageUploader_imagePreview__MkZ3z {
  width: 160px;
  height: 160px;
  object-fit: cover;
  border-radius: 4px;
  border: 1px solid #ccc;
}
.ImageUploader_deleteImageButton__Km1Yo {
  position: absolute;
  top: -8px;
  right: -8px;
  background: #e53935;
  color: #fff;
  border: none;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  cursor: pointer;
  font-size: 1em;
  line-height: 1;
}
`, "",{"version":3,"sources":["webpack://./src/Components/ImageUploader/ImageUploader.module.css"],"names":[],"mappings":"AAAA,iCAAiC;AACjC;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,cAAc;EACd,cAAc;AAChB","sourcesContent":["/* Post.module.cssの該当部分をコピーして流用 */\r\n.imageUploadBlock {\r\n  margin-bottom: 12px;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n.addImageButton {\r\n  margin-left: 8px;\r\n  padding: 2px 10px;\r\n  background: #1976d2;\r\n  color: #fff;\r\n  border: none;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n}\r\n.imagePreviewArea {\r\n  display: flex;\r\n  gap: 8px;\r\n  margin-top: 8px;\r\n}\r\n.imagePreviewWrapper {\r\n  position: relative;\r\n}\r\n.imagePreview {\r\n  width: 160px;\r\n  height: 160px;\r\n  object-fit: cover;\r\n  border-radius: 4px;\r\n  border: 1px solid #ccc;\r\n}\r\n.deleteImageButton {\r\n  position: absolute;\r\n  top: -8px;\r\n  right: -8px;\r\n  background: #e53935;\r\n  color: #fff;\r\n  border: none;\r\n  border-radius: 50%;\r\n  width: 20px;\r\n  height: 20px;\r\n  cursor: pointer;\r\n  font-size: 1em;\r\n  line-height: 1;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"imageUploadBlock": `ImageUploader_imageUploadBlock__SlETU`,
	"addImageButton": `ImageUploader_addImageButton__gRKJT`,
	"imagePreviewArea": `ImageUploader_imagePreviewArea__wOZBI`,
	"imagePreviewWrapper": `ImageUploader_imagePreviewWrapper__9vgXg`,
	"imagePreview": `ImageUploader_imagePreview__MkZ3z`,
	"deleteImageButton": `ImageUploader_deleteImageButton__Km1Yo`
};
export default ___CSS_LOADER_EXPORT___;
